import type { ComponentType } from 'react';
import LewisStructure from './LewisStructure';
import VseprGeometry from './VseprGeometry';
import BondPolarity from './BondPolarity';
import IntermolecularForces from './IntermolecularForces';
import BondFormation from './BondFormation';

// Bonding / molecular-structure interactive widgets. Each takes a resilient
// { config, onComplete } interface and is keyed by its slide `type`. Consumed
// by WidgetRenderer.tsx via this cluster registry.
export const BONDING_WIDGETS: Record<
  string,
  ComponentType<{ config: any; onComplete?: () => void }>
> = {
  lewis_structure: LewisStructure,
  vsepr_geometry: VseprGeometry,
  bond_polarity: BondPolarity,
  imf: IntermolecularForces,
  bond_formation: BondFormation,
};

export { default as LewisStructure } from './LewisStructure';
export { default as VseprGeometry } from './VseprGeometry';
export { default as BondPolarity } from './BondPolarity';
export { default as IntermolecularForces } from './IntermolecularForces';
export { default as BondFormation } from './BondFormation';

export type { LewisStructureConfig } from './LewisStructure';
export type { VseprGeometryConfig } from './VseprGeometry';
export type { BondPolarityConfig } from './BondPolarity';
export type { IntermolecularForcesConfig } from './IntermolecularForces';
export type { BondFormationConfig } from './BondFormation';
